import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const Accordion = dynamic(() => import('./Accordion'));

export const defaultOptions = {
	heading: '<h2>Frequently Asked Questions</h2>',
	tabs: [
		{ question: 'Placeholder Question?', answer: '<p>Placeholder answer.</p>' },
		{ question: 'Placeholder Question?', answer: '<p>Placeholder answer.</p>' },
	],
} as const;

Builder.registerComponent(Accordion, {
	name: 'Accordion',
	inputs: [
		{
			name: 'heading',
			friendlyName: 'Heading',
			type: 'richText',
			required: true,
			defaultValue: defaultOptions.heading,
		},
		{
			name: 'tabs',
			friendlyName: 'Tabs',
			type: 'list',
			copyOnAdd: false,
			subFields: [
				{
					name: 'question',
					friendlyName: 'Question',
					type: 'string',
					required: true,
					defaultValue: 'Placeholder Question?',
				},
				{
					name: 'answer',
					friendlyName: 'Answer',
					type: 'richText',
					required: true,
					defaultValue: '<p>Placeholder answer.</p>',
				},
			],
			defaultValue: [...defaultOptions.tabs],
		},
	],
	image: getIconUrl(Icon.ACCORDION),
});
